export const FooterNewStyles = {
    container: {
        backgroundColor: "#F0F0F0",
        px: { xs: '27px', sm: '30px', md: '40px', lg: '90.5px' },
        pt: { xs: '33.32px', sm: '27.13px' },
        pb: { xs: '15.99px', sm: '33.32px' },
        fontFamily: "Lexend",
    },
    containerContent: {
        maxWidth: "1650px",
        width: "100%",
        margin: "0 auto",
    },
    getInTouch: {
        fontSize: "13px",
        fontFamily: "Lexend",
        fontWeight: "400",
        color: "#0F0F0F",
    },
    faq: {
        fontSize: '13px',
        fontWeight: '400',
        color: '#0F0F0F',
        mt: '12px'
    },
    emailText: {
        fontSize: { xs: "11px", sm: "13px" },
        fontWeight: '400',
        color: '#000000',
        mt: { xs: '25.45px', sm: '34.19px' }
    },
    emailContainer: {
        display: "flex",
        mt: { xs: '9.3px', sm: '12.2px' },
        justifyContent: { xs: "center", sm: "flex-start" }
    },
    emailInput: {
        width: "100%",
        maxWidth: { xs: "222.42px", sm: "281.16px" },
        height: { xs: "35.47px", sm: "43.85px" },
        borderRadius: "0 !important",
        border: "none !important",
        backgroundColor: "#fff",
        '& .MuiInputBase-input': {
            border: "none !important",
            borderRadius: "0 !important",
            height: { xs: "35.47px", sm: "43.85px" },
            padding: "0 16px",
        },
        '& .MuiInputBase-root': {
            border: "none !important",
            borderRadius: "0 !important",
            backgroundColor: "#fff",
            height: { xs: "35.47px", sm: "43.85px" },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: "none !important",
            borderRadius: "0 !important",
        },
        '& .MuiOutlinedInput-root': {
            border: "none !important",
            borderRadius: "0 !important",
            backgroundColor: "#fff",
            height: { xs: "35.47px", sm: "43.85px" },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                border: "none !important",
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                border: "none !important",
            },
        },
    },
    subscribeButton: {
        width: { xs: "81.57px", sm: "100.84px" },
        fontFamily: "Lexend",
        backgroundColor: "#000",
        color: "#fff",
        borderRadius: "0",
        fontSize: { xs: "10.46px", sm: "12.93px" },
        fontWeight: "400",
        textTransform: "none",
        p: '0px'
    },
    footerLogo: {
        width: '157.89px',
        height: '16.78px'
    },
    footerText: {
        fontSize: '8px',
        fontFamily: "Lexend",
        fontWeight: '400',
        color: '#0F0F0F',
        mt: '12.17px'
    },
    downloadText: {
        fontSize: '13px',
        fontFamily: "Lexend",
        fontWeight: '400',
        color: '#0F0F0F',
    },
    downloadContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '21.31px',
        mt: '11.25px',
        mr: '-9px'
    },
    appStoreLogo: {
        cursor: 'pointer',
        width: '13.67px',
        height: '16px',
        '&:hover': {
            transform: 'scale(1.15)',
        }
    },
    googlePlayLogo: {
        cursor: 'pointer',
        width: '14.63px',
        height: '16px',
        '&:hover': {
            transform: 'scale(1.15)',
        }
    },
    copyrightText: {
        fontSize: '10px',
        fontFamily: "Lexend",
        fontWeight: '400',
        color: '#656565',
    },
    pptc: {
        fontSize: '10px',
        fontFamily: "Lexend",
        fontWeight: '400',
        '&:hover': {
            color: '#000000 !important',
            textDecoration: 'underline !important',
        }
    },
    clickableText: {
        textDecoration: 'none',
        color: '#656565',
    },
    socialContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '18.06px',
        mr: '-9px'
    },
    socialLogo: {
        cursor: 'pointer',
        width: '20px',
        height: '20px',
        '&:hover': {
            transform: 'scale(1.15)',
        }
    }
}